export default "__VITE_ASSET__BCB_YpVY__"